
import { Box } from '@mui/system';
import '../App.css';
import { BackButton, BackgroundStyle, BigHeading, LightBlueContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import { contractPageName } from '../components/PageName';
import { useNavigate } from 'react-router-dom';
import FormInput from '../components/FormInput';
import { useEffect, useState } from 'react';
import FormDatePicker from '../components/FormDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import FormTextarea from '../components/FormTextarea';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useLazyGetContractByIdQuery, useUpdateContractMutation } from '../features/contract/ContractSlice';
import { useTranslation } from "react-i18next";
import { AddUserContainer } from '../components/Containers/AddUserContainer';
import { useForm } from 'react-hook-form';
import HookFormInput from '../components/HookFormInput';
import HookFormDatePicker from '../components/HookFormDatePicker';
import HookFormTextarea from '../components/HookFormTextarea';
import { AddContractContainer } from '../components/Containers/AddContractContainer';

const AddContractPage = () => {
    const { register, getValues, handleSubmit, setValue, watch, control, setError, formState: { errors } } = useForm<
        {
            number?: string
            title?: string
            startDate?: string
            endDate?: string
            remark?: string
            inspectors?: any[]
        }
    >()

    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const [setUpdateContractMutation, updateContract] = useUpdateContractMutation();
    const { t, i18n } = useTranslation();

    const onConfirm = async (value: any) => {
        setUpdateContractMutation(value)
            .then((respone) => {
                if ('error' in respone) {
                    alert("StatusCode: 400")
                    setOpen(false);
                }
                else {
                    alert("Update Success")
                    setOpen(false);
                    navigate('/contract-detail', { state: respone?.data?.id })
                }
            })
    }

    const onClose = function () {
        setOpen(false)
    }

    const openModal = function () {
        setOpen(true)
    }

    return (
        <MainContent type={contractPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <Box sx={{ display: "row" }}>
                        <BigHeading>{t("Add New Contract")}</BigHeading>
                    </Box>

                    <HookFormInput title={t("Contract No.")} register={() => register("number")} />
                    <HookFormInput title={t("Contract Title")} register={() => register("title")} />
                    <HookFormDatePicker title={t("Start Date")} name={"startDate"} control={control} />
                    <HookFormDatePicker title={t("End Date")} name={"endDate"} control={control} />
                    <HookFormTextarea title={t("Remark")} register={() => register("remark")} />
                    <AddUserContainer
                        label={t("Add Viewer")}
                        onSelectRows={(inspectors: any[]) => {
                            setValue("inspectors", inspectors)
                        }}
                        selectedRows={watch("inspectors")}
                        role="Inspector"
                    />

                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={openModal}>{t("Save")}</ShortBlueButton>
                        <BackButton onClick={() => { navigate('/contract') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>

            <ModalConfirmationBox description={t("Are you sure to add new contract?")} open={open} onClose={onClose} onConfirm={handleSubmit(onConfirm)} />
        </MainContent>
    );
};

export default AddContractPage;